import type { Profile } from '../types/domain'

export function normalizePublicName(value: string) {
  return value.trim().replace(/\s+/g, ' ')
}

export function validPublicName(value: string) {
  const name = normalizePublicName(value)
  return name.length > 0 && name.length <= 50
}

export function hasCompleteProfile(profile: Profile | null) {
  return Boolean(profile && validPublicName(profile.display_name ?? ''))
}

/** Retain app navigation, without carrying auth tokens or allowing external redirects. */
export function profileReturnTo(value: string | null) {
  if (!value?.startsWith('/') || value.startsWith('//')) return '/profilo'
  try {
    const url = new URL(value, 'https://h24.local')
    if (url.origin !== 'https://h24.local') return '/profilo'
    const allowed = url.pathname === '/' || url.pathname === '/profilo' || url.pathname === '/admin' || url.pathname.startsWith('/citta/')
    if (!allowed) return '/profilo'
    const keys = url.pathname === '/' || url.pathname.startsWith('/citta/') ? ['punto', 'aggiungi'] : url.pathname === '/admin' ? ['sezione', 'revisione'] : []
    for (const key of [...url.searchParams.keys()]) if (!keys.includes(key)) url.searchParams.delete(key)
    return `${url.pathname}${url.search}`
  } catch { return '/profilo' }
}
